import React from 'react';
import { Progress } from 'antd';

const LoginLoader = () => {
  return (
    <Progress
      percent={100}
      status="active"
      showInfo={false}
      strokeColor="rgb(0, 188, 212)"
    />
  );
};

export default LoginLoader;
